import * as tslib_1 from "tslib";
import * as React from 'react';
import { StyledIconBase } from '../../StyledIconBase';
export var Thermometer = React.forwardRef(function (props, ref) {
    var attrs = {
        "fill": "currentColor",
    };
    return (React.createElement(StyledIconBase, tslib_1.__assign({ iconAttrs: attrs, iconVerticalAlign: "middle", iconViewBox: "0 0 24 24" }, props, { ref: ref }),
        React.createElement("path", { d: "M13 17c0-1.569-.677-2.974-1.835-3.906l-.165-.33V5c0-1.654-1.346-3-3-3S5 3.346 5 5V12.764l-.165.33C3.677 14.026 3 15.431 3 17c0 .043.012.082.013.124.002.018.002.034.005.051C3.112 19.85 5.303 22 8 22s4.888-2.15 4.982-4.825c.003-.017.003-.033.005-.051.001-.042.013-.081.013-.124zM8 4c.552 0 1 .449 1 1v4H7V5c0-.551.448-1 1-1zm5-1h7v2h-7zm0 4h5v2h-5zm0 4h3v2h-3z", key: "k0" })));
});
Thermometer.displayName = 'Thermometer';
export var ThermometerDimensions = { height: 24, width: 24 };
